import React from "react";
import { FaLinkedin, FaGithubSquare } from "react-icons/fa";
import picture from "./CriticalFailDemo.png";
import pictur from "./Nota-POSDemo.png";
import "./reset.css";
import "./App.css";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <div className="Personal-Info">
          <h1>Ryland McGee</h1>
          <h2>Full Stack Developer</h2>
          <h2>Contact Info:</h2> <h2> mcgee.ryland@gmail.com,</h2>
          <h2> (724)-814-9845</h2>
          <h2>
            <a href="https://www.linkedin.com/in/ryland-mcgee/">
              <FaLinkedin className="links" />
            </a>{" "}
            <a href="https://github.com/RylandPM">
              <FaGithubSquare className="links" />
            </a>
          </h2>
        </div>
      </header>
      <div className="aboutMe">
        <h2>About Me:</h2>
        <div className="education">
          <h3>Education</h3>
          <p>Graduate of the DevMountain Web Development Course</p>
        </div>
      </div>
      <div className="Projects">
        <h2>Projects: </h2>
        <div className="CriticalFail">
          <h3>Critical Fail</h3>
          <div className="demo-display">
            <div className="Pinfo">
              <ul>
                <li>
                  Designed to test my skill and knowledge over a two week period
                </li>
                <li>
                  Creates and powers a basic tabletop RPG board and message app
                </li>
                <li>
                  Makes use of React-Redux and Socket.io to ensure interaction
                  between multiple sessions
                </li>
              </ul>
              <h4>
                Live version:{" "}
                <a href="https://www.criticalfailco.com/#/">
                  https://www.criticalfailco.com/#/
                </a>
              </h4>
              <h4>
                Check it out on GitHub:{" "}
                <a href="https://github.com/RylandPM/Critical-Fail">
                  https://github.com/RylandPM/Critical-Fail
                </a>
              </h4>
            </div>
            <img src={picture} />
          </div>
        </div>
        <div className="CriticalFail">
          <h3>Nota-POS</h3>
          <div className="demo-display">
            <div className="Pinfo">
              <ul>
                <li>
                  A POS system made to escape the antiquated nature of its
                  predecessors
                </li>
                <li>
                  Built entirely using mongoDB to capitalize on the nested
                  collection structure
                </li>
                <li>
                  Constructed over a two week period with a team of three as our
                  final project at DevMountain
                </li>
              </ul>
              {/* <h4>
                Live version:{" "}
                <a href="https://www.criticalfailco.com/#/">
                  https://www.criticalfailco.com/#/
                </a>
              </h4> */}
              <h4>
                Check it out on GitHub:{" "}
                <a href="https://github.com/CurtBryan/nota-pos">
                  https://github.com/CurtBryan/nota-pos
                </a>
              </h4>
            </div>
            <img src={pictur} />
          </div>
        </div>
      </div>
      <footer>
        <div>
          mcgee.ryland@gmail.com{" "}
          <a href="https://www.linkedin.com/in/ryland-mcgee/">
            <FaLinkedin className="links" />
          </a>{" "}
          <a href="https://github.com/RylandPM">
            <FaGithubSquare className="links" />
          </a>
        </div>
      </footer>
    </div>
  );
}

export default App;
